import { defineMessages } from 'react-intl';

export default defineMessages({
  wrongOperatorHintSecondaryText: {
    id: 'frontbucket.search.results.wrongOperatorHintSecondaryText',
    description: 'Syntax hint label',
    defaultMessage: 'Need help with your search?',
  },
  wrongExtensionHintSecondaryText: {
    id: 'frontbucket.search.results.wrongExtensionHintSecondaryText',
    description: 'Syntax hint label',
    defaultMessage:
      'The extension modifier can only filter the last extension for filenames with multiple extensions.',
  },
  syntaxHintMessage: {
    id: 'frontbucket.search.results.syntaxHintMessage',
    description: 'Syntax hint message',
    defaultMessage: '{learnMoreLink} about search syntax.',
  },
  syntaxLearnMoreLink: {
    id: 'frontbucket.search.results.syntaxLearnMoreLink',
    description: 'Link to learn more about search syntax',
    defaultMessage: 'Learn more',
  },
});
